// extracted by mini-css-extract-plugin
module.exports = {"ProfileHeads":"ProfileHeads_ProfileHeads__qIZ4j"};